import { isEqual } from 'lodash';
import moment from 'moment';

const INIT_STATE = {
  list: [],
};

export default function pickReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case `@oms/PICK_GROUP_LINES`: {
      const selectedLines = action.data;

      const groupedLines = selectedLines.reduce((obj, controlRecord) => {
        const itemLine = obj[controlRecord.item_id];
        controlRecord.picked_quantity = 0;
        controlRecord.total_picked_quantity = 0;
        if (!itemLine) {
          obj[controlRecord.item_id] = {
            ...controlRecord,
            id: controlRecord.item_id,
            _id: controlRecord.item_id,
            total_quantity: Number(controlRecord.quantity),
            total_picked_quantity: 0,
            oms_control_records: [controlRecord],
          };
        } else {
          obj[controlRecord.item_id].total_quantity += Number(controlRecord.quantity);
          obj[controlRecord.item_id].oms_control_records.push(controlRecord);
        }

        return obj;
      }, {});

      return {
        ...state,
        list: Object.values(groupedLines),
      };
    }

    case '@oms/UPDATE_PICK_CONTROL_RECORD': {
      const { list } = state;
      const { payload } = action;
      const updatedList = list.map((listItem) => {
        const controlRecords = listItem.oms_control_records.map((cr) => {
          return isEqual(cr.id, payload.id)
            ? {
                ...payload,
                update_time: moment().format(),
                picked_quantity: payload.picked_quantity,
              }
            : cr;
        });
        const totalPickedQty = controlRecords.reduce(
          (total, { picked_quantity, id }) => {
            return total + (picked_quantity || 0);
          },
          0,
        );
        return {
          ...listItem,
          collapsed: !(payload.item_id === listItem.item_id),
          total_picked_quantity: totalPickedQty,
          update_time: moment().format(),
          oms_control_records: controlRecords,
        };
      });

      return {
        ...state,
        list: updatedList,
      };
    }

    case `@oms/PICK_FORM`: {
      return {
        ...state,
        form: action.data,
      };
    }

    default:
      return state;
  }
}
